import './save-search.less';
import template from './save-search.html';

export default angular.module('cian.newbuild.filter.saveSearch', [])
.factory('SaveSearchService',
['$rootScope', '$log', '$uibModal',
($rootScope, $log, $uibModal) => {
  const service = {};

  /**
   * open modal 'save search filter'
   * http://s.csssr.ru/2016-03-16-2214-1fs0n068qj.png
   * @return modal instance
   */
  function openModal() {
    return $uibModal.open({
      scope: $rootScope.$new(),
      controller: 'SaveSearchController',
      controllerAs: 'saveSearch',
      template,
    });
  }

  /**
   * @public
   * @return {Promise}
   */
  service.saveSearch = function SaveSearchServiceSaveSearch() {
    return openModal();
  };

  return service;
}])

.controller('SaveSearchController',
['$log', 'ApiService', '$uibModalInstance', 'FilterService', 'StateService', 'AnalyticsService', 'SerpListService', 'MetaService',
($log, ApiService, $uibModalInstance, FilterService, StateService, AnalyticsService, SerpListService, MetaService) => {
  const ctrl = {};

  ctrl.subscribe = true;
  ctrl.email = StateService.email;
  let filterParams;

  function updateData(meta) {
    ctrl.searchTitle = meta ? meta.h1 : SerpListService.getSearchTitle();

    const urlParser = document.createElement('a');
    urlParser.href = meta ? meta.fullUrlWithoutSeo : SerpListService.getFullUrl();
    filterParams = urlParser.search;
  }

  if (MetaService.isUpdating()) {
    ctrl.isLoading = true;
    MetaService.onReceive(data => {
      updateData(data);
      ctrl.isLoading = false;
    });
  } else {
    updateData(MetaService.lastMeta);
  }

  ctrl.invalid = field => ctrl.form.$submitted && ctrl.form[field].$invalid;

  ctrl.isEmailInvalid = () => (
    ctrl.subscribe && ctrl.form.$submitted && ctrl.form.email.$invalid
  );

  const successSave = () => {
    $uibModalInstance.close();

    // Генерим лэйбл с перечислением параметров запроса
    let gaLabel = ctrl.subscribe ? 'sbscr' : '';
    const regexp = /[\?&](\w*)/g;
    for (let p; p = regexp.exec(filterParams); ) {
      const gaParam = p[1];
      const excludedParams = [
        'new_iface',
        'engine_version',
        'type',
        'sort',
        'quality',
      ];
      if (!excludedParams.includes(gaParam)) {
        gaLabel += (gaLabel ? '/' : '') + gaParam;
      }
    }

    AnalyticsService.trackCA('Listing', 'Save_filter', gaLabel);
    window.ca && ca('event', {
      name: 'oldevent',
      category: 'subscription',
      action: 'Send',
      label: 'From_cat_save',
    });

    if (ctrl.subscribe) {
      AnalyticsService.trackCA('subscription', 'Send', 'From_saved_search');
    }
  };

  const failSave = err => {
    $log.error(err);
  };

  /**
   * handle on click on save button
   * @return {Promise} $http request
   */
  ctrl.save = () => {
    ctrl.form.email.$setValidity('email', !ctrl.isEmailInvalid());

    if (ctrl.form.$invalid) {
      return;
    }

    const data = {
      email: ctrl.subscribe ? ctrl.email : null,
      dealType: FilterService.dealType,
      title: ctrl.searchTitle,
      filterParams, // url
    };

    return ApiService.saveSearch(data)
      .then(successSave)
      .catch(failSave);
  };
  return ctrl;
}])
.name;



// WEBPACK FOOTER //
// ./src/serp/services/save-search/save-search.service.js